import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { EDIT } from "const"
import { hasProjectAccess } from "client/utils"
import {
    PRM_STUDY,
    StoreType,
    addModal,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Input,
    Textarea,
    DateFormatter,
    DivInput,
    Empty,
    UserIcon,
    Button,
} from "client/components"

const Form = () => {
    const baseRoute = useSelector((state: StoreType) => state.study.baseRoute)
    const study = useSelector((state: StoreType) => state.study.studyView)
    const categoryList = useSelector((state: StoreType) => state.rrsCategory.categoryList)
    const categoryChildParent = useSelector((state: StoreType) => state.rrsCategory.categoryChildParent)

    const projectSettings = useSelector((state: StoreType) => state.project.projectSettings)
    const accountSettings = useSelector((state: StoreType) => state.system.accountSettings)
    const userList = useSelector((state: StoreType) => state.user.userList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [systemStageCategory, setSystemStageCategory] = useState<string>(null)
    const [statusCategory, setStatusCategory] = useState<string>(null)

    useEffect(() => {
        let parentArray: string[]
        const addParent = (parentId: number) => {
            if (parentId) {
                const parent = categoryList[parentId]
                if (parent) parentArray.unshift(parent.shortName.length ? parent.shortName : parent.name)
                addParent(categoryChildParent[parentId])
            }
        }

        parentArray = []
        addParent(study.systemStageId)
        setSystemStageCategory(parentArray.length ? parentArray.join(" > ") : null)

        parentArray = []
        addParent(study.statusId)
        setStatusCategory(parentArray.length ? parentArray.join(" > ") : null)
    }, [categoryList, categoryChildParent, study])

    const { studyFields } = projectSettings.study.studyFieldsAssigned ? projectSettings.study : accountSettings.study

    const editUrl = `${baseRoute}/${EDIT}/${study.id}`
    const editAccess = hasProjectAccess(PRM_STUDY, EDIT)

    const fields: any[] = []
    if (studyFields.systemStage) {
        fields.push(
            <FormGroup key="systemStage">
                <Label>{lang.systemStage}</Label>
                <DivInput widePadding>{systemStageCategory || <Empty />}</DivInput>
            </FormGroup>,
        )
    }
    if (studyFields.studyStatus) {
        fields.push(
            <FormGroup key="studyStatus">
                <Label>{lang.status}</Label>
                <DivInput widePadding>{statusCategory || <Empty />}</DivInput>
            </FormGroup>,
        )
    }
    if (studyFields.location) {
        fields.push(
            <FormGroup key="location">
                <Label>{lang.location}</Label>
                <Input type="text" value={study.location} readOnly />
            </FormGroup>,
        )
    }
    if (studyFields.site) {
        fields.push(
            <FormGroup key="site">
                <Label>{lang.site}</Label>
                <Input type="text" value={study.site} readOnly />
            </FormGroup>,
        )
    }
    if (studyFields.plant) {
        fields.push(
            <FormGroup key="plant">
                <Label>{lang.plant}</Label>
                <Input type="text" value={study.plant} readOnly />
            </FormGroup>,
        )
    }
    if (studyFields.group) {
        fields.push(
            <FormGroup key="group">
                <Label>{lang.group}</Label>
                <Input type="text" value={study.group} readOnly />
            </FormGroup>,
        )
    }
    if (studyFields.unit) {
        fields.push(
            <FormGroup key="unit">
                <Label>{lang.unit}</Label>
                <Input type="text" value={study.unit} readOnly />
            </FormGroup>,
        )
    }
    if (studyFields.subUnit) {
        fields.push(
            <FormGroup key="subUnit">
                <Label>{lang.subUnit}</Label>
                <Input type="text" value={study.subUnit} readOnly />
            </FormGroup>,
        )
    }

    const maxColumnLength = fields.length / 2 + (fields.length % 2)

    const fields1 = fields.slice(0, maxColumnLength)
    const fields2 = fields.slice(maxColumnLength)

    return (
        <PageForm>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.name}</Label>
                        <Input type="text" value={study.name} readOnly />
                    </FormGroup>
                    {
                        studyFields.description && (
                            <FormGroup>
                                <Label>{lang.description}</Label>
                                <Textarea value={study.description} readOnly />
                            </FormGroup>
                        )
                    }

                    <FormGroup>
                        <Label>{lang.timeframe}</Label>
                        <FormGroup inline>
                            <DivInput widePadding><DateFormatter date={study.dateStart} showTime={false} /></DivInput>
                            <DivInput widePadding><DateFormatter date={study.dateEnd} showTime={false} /></DivInput>
                        </FormGroup>
                    </FormGroup>

                    {
                        studyFields.manager && (
                            <FormGroup>
                                <Label>{lang.manager}</Label>
                                <DivInput><UserIcon user={userList[study.managerId]} size="sm" /></DivInput>
                            </FormGroup>
                        )
                    }
                </Col>

                {
                    (fields1.length && fields2.length)
                        ? ([
                            <Col key="fields1" xs={6}>
                                {fields1.map((field) => field)}
                            </Col>,
                            <Col key="fields2" xs={6}>
                                {fields2.map((field) => field)}
                            </Col>,
                        ])
                        : (
                            <Col xs={12}>
                                {fields.map((field) => field)}
                            </Col>
                        )
                }

                {
                    editAccess && (
                        <Col xs={12}>
                            <Button onClick={() => dispatch(addModal({ url: editUrl }))}>
                                {lang.edit}
                            </Button>
                        </Col>
                    )
                }
            </Row>
        </PageForm>
    )
}
export default Form
